import React from "react";
import FaqSection from "components/FaqSection";
import GuideSection from "components/GuideSection";
import Link from "next/link";
import SideBar from "./SideBar";
import { HeaderH2, HeaderH1, Text, NextButton, ImageBlock } from "components/TextBlocks";
import Image from "next/image";

function Combine(props) {
  const keyCss = {
    fontSize: "1rem",
    fontFamily: "menlo, consolas, monospace",
    border: "1px solid #DDDDDD",
    borderRadius: "5px",
    boxShadow: "0 4px 8px -1px rgba(201,204,208,0.90)",
    backgroundColor: "#FFF",
    paddingTop: "4px",
    paddingBottom: "4px",
    paddingLeft: "7px",
    paddingRight: "6px",
  };
  return (
    <>
      <HeaderH1>Combine items</HeaderH1>
      <Text>
        To combine items drag and hold a comment or site over another comment or site and release.
      </Text>
      <ImageBlock
        src={"/guide/combine_items.png"}
        width={504}
        height={292}
        quality={100}
        alt={"Combine two items"}
      />
      <Text>
        When you combine sites they will turn into a stack, putting them sites side-by-side instead
        of in a list.
      </Text>
      <ImageBlock
        src={"/guide/stack_sites.png"}
        width={460}
        height={350}
        quality={100}
        alt={"Combine sites"}
      />
      <Text>
        You can also achieve this by selecting multiple sites and clicking the combine icon:
      </Text>
      <ImageBlock
        src={"/guide/merge_items.png"}
        width={374}
        height={145}
        quality={100}
        alt={"Merge sites"}
      />
      <Text>
        Once stacked the items can be rearranged and edited by clicking the expand chevron in the
        right corner of the item. To remove a item from the stack, drag the item outside of the
        stacked area and let go.
      </Text>
      <ImageBlock
        src={"/guide/stacked_dnd.png"}
        width={457}
        height={462}
        quality={100}
        alt={"Merge sites"}
      />
      <NextButton
        cta={"Save text-snippets"}
        textColor={"#565D65"}
        bg={"#EBECED"}
        page={"/guide/save-text-snippet"}
      />
    </>
  );
}

Combine.Layout = SideBar;

export default Combine;
